import { LinkIcon } from 'lucide-react';
import { FC } from 'react';

import { useIntegrations } from '@/entities/integrations';
import { SidebarNavItem } from '@/shared/ui';

/**
 * Динамическое подменю активных интеграций под пунктом "Интеграции".
 *
 * Каждая активная интеграция отображается отдельным пунктом меню,
 * клик по которому ведёт на /integrations/{code}.
 */
export const IntegrationsDynamicMenu: FC = () => {
  const { data } = useIntegrations({ isActive: true, limit: 100 });

  const items = data?.items ?? [];
  if (items.length === 0) {
    return null;
  }

  return (
    <>
      {items.map((integration) => (
        <SidebarNavItem
          key={integration.code}
          path={`/integrations/${integration.code}`}
          icon={<LinkIcon size={16} strokeWidth={1.25} className="text-muted-foreground" />}
          label={integration.name}
          tooltip={integration.name}
        />
      ))}
    </>
  );
};
